import { useQuery } from '@apollo/react-hooks';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

import { FIND_SORTED_PRODUCT_APPROVALS } from 'graphql/queries';

const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

interface IApprovementsProps {
  productId: string;
}

const Approvements = ({ productId }: IApprovementsProps) => {
  const classes = useStyles();
  const { data, loading, error, refetch } = useQuery(FIND_SORTED_PRODUCT_APPROVALS, {
    variables: {
      productId,
    },
    fetchPolicy: 'cache-and-network',
  });
  // console.log('!!!approvements', data);
  const approvements = data?.findSortedProductApprovals || [];
  let title = `Approvements (${approvements.length})`;
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography className={classes.heading}>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div style={{ width: '100%' }}>
          {approvements.length === 0 && <Typography>No approvements</Typography>}
          {approvements.length > 0 && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>approvedAt</TableCell>
                    <TableCell>approvedBy</TableCell>
                    <TableCell>organizationGroupIdentifier</TableCell>
                    <TableCell>state</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {approvements.map((approvement: any) => (
                    <TableRow key={approvement.productId}>
                      <TableCell>{approvement.approvedAt && new Date(approvement.approvedAt).toUTCString()}</TableCell>
                      <TableCell>{approvement.approvedBy}</TableCell>
                      <TableCell>{approvement.organizationGroupIdentifier}</TableCell>
                      <TableCell>{approvement.state}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default Approvements;
